// MOBIL-KÜSZÖB — egyetlen igazság-forrás ahhoz a kérdéshez, hogy „telefon-széles-e a felület".
//
// MIÉRT A KÖZÖS RÉTEGBEN: a megbeszélés-naptár már hordozta ugyanezt a `matchMedia`-logikát inline (a legacy
// `isMobile` párja), és a kampány-előrejelzés lett a MÁSODIK hívó — a repo szabálya szerint a 2. másolatnál a
// közös rétegbe kerül. Két külön küszöb-konstans idővel elcsúszna, és a két lap más szélességnél váltana.
//
// MIÉRT NEM TAILWIND-BREAKPOINT: a `md:`/`sm:` osztályok CSAK a megjelenést tudják váltani, a VISELKEDÉST nem.
// Itt viszont a komponens LOGIKÁJA függ tőle (a naptár más nézet-készletet regisztrál, az idősáv más
// nagyítással számol) — azt JS-ből kell tudni. A küszöb szándékosan a Tailwind `sm` (640px) ALATTI sávot
// jelöli: e fölött már elfér a teljes vezérlő-sor.
//
// Az átméretezést/elforgatást KÖVETI (`change` esemény) — enélkül egy landscape-be forgatott telefon a
// mobil-elrendezésben ragadt volna.
import { useEffect, useState } from 'react';

/** E szélesség ALATT (és rajta) mobil-elrendezés. A Tailwind `sm` breakpointja. */
export const MOBILE_MAX_WIDTH = 640;

const QUERY = `(max-width: ${String(MOBILE_MAX_WIDTH)}px)`;

/**
 * Igaz, ha a felület telefon-széles. SSR-biztos: `window` hiányában `false` (a szélesebb elrendezés a
 * biztonságos alap — az mindig renderelhető, csak sűrűbb).
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window === 'undefined' ? false : window.matchMedia(QUERY).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (): void => setIsMobile(mql.matches);
    setIsMobile(mql.matches); // a mount és az első effekt között változhatott (pl. elforgatás)
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return isMobile;
}
